import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder.tsx';
import type { DirectDealsListItem } from '@openx/types/directDeals.ts';
import { useTranslation } from 'react-i18next';

type AudienceDistributionCellProps = Pick<
  DirectDealsListItem,
  'audience_distribution_female' | 'audience_distribution_male' | 'audience_distribution_other'
>;

export const AudienceDistributionCell = ({
  audience_distribution_female,
  audience_distribution_male,
  audience_distribution_other,
}: AudienceDistributionCellProps) => {
  const { t } = useTranslation();

  const hasNoAudienceData =
    !audience_distribution_female && !audience_distribution_male && !audience_distribution_other;

  if (hasNoAudienceData) return <ValuePlaceholder />;

  return (
    <Stack data-test="audience-distribution-cell">
      {!!audience_distribution_male && (
        <Stack
          direction="row"
          spacing={0.5}
          data-test="audience-distribution-male"
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography variant="body1" color="textSecondary">
            {t('Male: ')}
          </Typography>
          <Typography variant="body1">{`(${audience_distribution_male} %)`}</Typography>
        </Stack>
      )}
      {!!audience_distribution_female && (
        <Stack
          direction="row"
          spacing={0.5}
          data-test="audience-distribution-female"
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography variant="body1" color="textSecondary">
            {t('Female: ')}
          </Typography>
          <Typography variant="body1">{`(${audience_distribution_female} %)`}</Typography>
        </Stack>
      )}
      {!!audience_distribution_other && (
        <Stack
          direction="row"
          spacing={0.5}
          data-test="audience-distribution-other"
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography variant="body1" color="textSecondary">
            {t('Other: ')}
          </Typography>
          <Typography variant="body1">{`(${audience_distribution_other} %)`}</Typography>
        </Stack>
      )}
    </Stack>
  );
};
